export const getSubstringIndices = (str, subStr = '') => {
  if (subStr.length === 0) {
    return [0]
  }
  const indices = []
  let index = str.indexOf(subStr)
  while (index !== -1) {
    indices.push(index)
    index = str.indexOf(subStr, index + 1)
  }
  return indices
}
